<template>
  <div v-if="isClient && (viqOverride || (hasSomeAccess && !shouldBlockViq))">
    <div id="pickaxe-wrapper">
      <div id="pickaxe-container"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VIQ",
  data() {
    return {
      isClient: typeof window !== "undefined",
      scriptInjected: false,
      unsubscribeStore: null,
    };
  },
  computed: {
    viqOverride() {
      return this.$store.state.Auth?.subscriptions?.viq_override === true;
    },
    hasFullRegionalAccess() {
      return !!(this.$store.state.Auth?.subscriptions?.full_regional_access);
    },
    hasSomeAccess() {
      return this.hasFullRegionalAccess;
    },
    shouldBlockViq() {
      return this.$store.state.Auth?.subscriptions?.block_viq === true;
    },
  },
  mounted() {
    // Evaluate immediately on mount (site-wide behaviour)
    this.evaluateAndToggleViq();

    // React to Vuex changes (viq_override or subscription flags arriving async)
    if (this.isClient && this.$store && this.$store.subscribe) {
      this.unsubscribeStore = this.$store.subscribe((mutation, state) => {
        // Re-evaluate on any mutation; cheap and reliable
        this.evaluateAndToggleViqFromState(state);
      });
    }
  },
  beforeDestroy() {
    if (this.unsubscribeStore) {
      this.unsubscribeStore();
      this.unsubscribeStore = null;
    }
    this.destroyViq();
  },
  methods: {
    getDeploymentId() {
      if (this.viqOverride) {
        return "deployment-b12739c8-b36d-482f-b924-09c9d8b27eb7";
      }
      if (this.hasFullRegionalAccess) {
        return "deployment-b12739c8-b36d-482f-b924-09c9d8b27eb7";
      }
      return null;
    },

    evaluateAndToggleViq() {
      const shouldShow = this.viqOverride || (this.hasSomeAccess && !this.shouldBlockViq);
      if (shouldShow) {
        this.rebuildViq();
      } else {
        this.destroyViq();
      }
    },

    evaluateAndToggleViqFromState(state) {
      const s = state.Auth?.subscriptions || {};
      const shouldShowNow = s.viq_override === true || (s.full_regional_access === true && s.block_viq !== true);
      if (shouldShowNow) {
        this.rebuildViq();
      } else {
        this.destroyViq();
      }
    },

    rebuildViq() {
      // If blocked (and override is not present), don't build
      if (!this.viqOverride && this.shouldBlockViq) {
        return;
      }

      const deploymentId = this.getDeploymentId();
      if (!deploymentId) {
        return;
      }

      if (document.getElementById(deploymentId)) {
        return;
      }

      const container = document.getElementById("pickaxe-container");
      if (!container) {
        return;
      }

      const embed = document.createElement("div");
      embed.id = deploymentId;
      container.appendChild(embed);

      if (!this.scriptInjected) {
        const script = document.createElement("script");
        script.src = "https://studio.pickaxe.co/api/embed/bundle.js";
        script.defer = true;

        script.onload = () => {
          setTimeout(() => this.observePickaxeBox(deploymentId), 300);
        };
        script.onerror = () => {
          /* handle script load error if needed */
        };

        document.head.appendChild(script);
        this.scriptInjected = true;

        // Fallback observer in case onload isn't triggered
        setTimeout(() => this.observePickaxeBox(deploymentId), 1500);
      } else {
        this.observePickaxeBox(deploymentId);
      }
    },

    observePickaxeBox(deploymentId) {
      const deployment = document.querySelector(`#${deploymentId}`);
      if (!deployment) {
        // try again shortly if embed hasn't been rendered yet
        setTimeout(() => this.observePickaxeBox(deploymentId), 300);
        return;
      }

      const applyStyles = () => {
        const drawer = deployment.querySelector(".pickaxe-embed > div.pxe-transition-h");
        if (drawer) {
          drawer.style.setProperty("border", "1px solid black", "important");
          drawer.style.setProperty("position", "fixed", "important");
          drawer.style.setProperty("right", "80px", "important");
          drawer.style.setProperty("bottom", "100px", "important");
        }

        const copyButtons = deployment.querySelectorAll(".pxe-mt-4.pxe-flex.pxe-gap-3");
        if (copyButtons) {
          copyButtons.forEach((btn) => {
            btn.style.setProperty("display", "none", "important");
          });
        }

        const fabButton = document.querySelector("button.pxe-fixed");
        if (fabButton) {
          fabButton.style.setProperty("right", "80px", "important");
          fabButton.style.setProperty("border", "2px solid black", "important");
          fabButton.style.setProperty("background-color", "#f0f0f0", "important");
        }
      };

      const observer = new MutationObserver(applyStyles);
      observer.observe(document.body, { childList: true, subtree: true });

      applyStyles();
    },

    destroyViq() {
      const container = document.getElementById("pickaxe-container");
      if (container) {
        container.innerHTML = "";
      }
    },
  },
};
</script>

<style scoped>
#pickaxe-wrapper {
  /* optional wrapper styles */
}
</style>
